if (!customElements.get('read-more-text')) {
  customElements.define(
    'read-more-text',
    class ReadMoreText extends HTMLElement {
      constructor() {
        super();
        this.toggleButton = this.querySelector('[data-read-more-toggle]');
        this.moreLabel = this.querySelector('[data-read-more-label-more]');
        this.lessLabel = this.querySelector('[data-read-more-label-less]');
        this.mobileOnly = this.classList.contains('rich-text__text-wrapper--mobile-only');
        this.desktopMedia = window.matchMedia('(min-width: 750px)');

        if (!this.toggleButton) return;

        this.setAttribute('data-expanded', 'false');
        this.toggleButton.addEventListener('click', this.toggle.bind(this));
        this.syncDesktopState = this.syncDesktopState.bind(this);
        this.syncDesktopState();

        if (this.mobileOnly && this.desktopMedia.addEventListener) {
          this.desktopMedia.addEventListener('change', this.syncDesktopState);
        }
      }

      syncDesktopState() {
        if (!this.mobileOnly) return;

        if (this.desktopMedia.matches) {
          this.setAttribute('data-expanded', 'true');
          this.toggleButton.setAttribute('aria-expanded', 'true');
          this.toggleButton.hidden = true;
          if (this.moreLabel) this.moreLabel.hidden = true;
          if (this.lessLabel) this.lessLabel.hidden = true;
          return;
        }

        this.setAttribute('data-expanded', 'false');
        this.toggleButton.hidden = false;
        this.toggleButton.setAttribute('aria-expanded', 'false');
        if (this.moreLabel) this.moreLabel.hidden = false;
        if (this.lessLabel) this.lessLabel.hidden = true;
      }

      toggle() {
        if (this.mobileOnly && this.desktopMedia.matches) return;

        const willExpand = this.getAttribute('data-expanded') !== 'true';
        this.setAttribute('data-expanded', String(willExpand));
        this.toggleButton.setAttribute('aria-expanded', String(willExpand));
        if (this.moreLabel) this.moreLabel.hidden = willExpand;
        if (this.lessLabel) this.lessLabel.hidden = !willExpand;
      }
    }
  );
}
